import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import NavBar from 'src/components/navBar';
import { SearchType } from 'src/constants/types';

type Props = {
  query: string;
  searchType: SearchType;
};
export default function SearchNavbar({ query, searchType }: Props) {
  const community = useSelector(({ context }) => context.currentCommunity);
  const queryLink = query ? `&query=${query}` : '';
  const asLink = query ? `?query=${query}` : '';

  const globalItems = [
    {
      link: `/search?searchType=posts${queryLink}`,
      as: `/search/posts${asLink}`,
      id: 'posts',
      content: i18n.t('Posts'),
    },
    {
      link: `/search?searchType=communities${queryLink}`,
      as: `/search/communities${asLink}`,
      id: 'communities',
      content: i18n.t('Communities'),
    },
  ];
  const communityItems = [
    {
      link: `/community/communitySearch?communitySlug=${community?.slug}&searchType=posts${queryLink}`,
      as: `/${community?.slug}/search/posts${asLink}`,
      id: 'posts',
      content: i18n.t('Posts'),
    },
    {
      link: `/community/communitySearch?communitySlug=${community?.slug}&searchType=members${queryLink}`,
      as: `/${community?.slug}/search/members${asLink}`,
      id: 'members',
      content: i18n.t('Members'),
    },
  ];

  const items = community?.slug ? communityItems : globalItems;

  return (
    <div data-testid="search-header-navbar">
      <NavBar items={items} selectedPage={searchType} />
    </div>
  );
}
